export function sc_sortedIndex(array, value) {
  var low = 0,
    high = array.length;

  while (low < high) {
    var mid = (low + high) >>> 1;
    if (array[mid].fDataObjID < value) low = mid + 1;
    else high = mid;
  }
  return low;
}
